<template>
  <div class="proxima--font">
    <ManageBaseTableHeader :title="$route.name" :is-searchable="false" />
    <v-row wrap class="faqs px-4 pt-2 pb-7">
      <v-col cols="12" sm="10" class="pl-4 center-column">
        <v-row wrap v-if="topics">
          <v-col cols="12" v-for="(topicName, i) of topics" :key="topicName">
            <div class="topic-name py-1">
              <h2 :id="slugMe(topicName)" class="mb-2"
                >{{ i + 1 }}. {{ topicName }}</h2
              >
              <v-divider></v-divider>
            </div>
            <ul v-if="faqByTopic[topicName]">
              <li
                v-for="faq of faqByTopic[topicName]"
                :key="faq.question"
                :id="`${slugMe(faq.question)}`"
                class="py-2 faq-wrap"
              >
                <!-- <v-icon left color="blue lighten-2" class="link-icon"
                        >mdi-link-variant</v-icon
                      > -->
                <v-row class="faq-question mb-2" dense>
                  <v-col cols="12" sm="auto" class="grow"
                    ><h3 class="font-weight-bold">
                      {{ faq.question }}</h3
                    ></v-col
                  >
                  <v-col cols="12" sm="auto" class="shrink" align-self="center"
                    ><v-btn
                      v-if="faq.video_url"
                      :href="faq.video_url"
                      target="_blank"
                      :x-small="$mq === 'xs'"
                      :small="$mq !== 'xs'"
                      outlined
                      rounded
                      color="teal accent-4"
                      >{{
                        ['xs', 'sm', 'md'].includes($mq)
                          ? 'Watch'
                          : 'Watch Video'
                      }}
                      <v-icon
                        right
                        :x-small="$mq === 'xs'"
                        :small="$mq !== 'xs'"
                        >mdi-play-circle-outline</v-icon
                      ></v-btn
                    ></v-col
                  >
                </v-row>

                <Markdown
                  v-if="faq.answer.length"
                  :source="faq.answer"
                  class="faq-answer"
                />
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="10">
        <v-divider class="mb-4" />
        <h2 class="font-weight-bold">Still Stumped?</h2>
        <p
          >Send an email to
          <a href="mailto:hi@getminimart.com">hi@getminimart.com</a>
          and we'll do our best to answer your questions quickly.</p
        >
      </v-col>
      <v-col cols="12" sm="10" class="mt-8 pb-0">
        <div class="grey--text body-2">Running Minimart {{ version }}</div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import slugMe from '@/utils/slugMe'
import _groupBy from 'lodash/groupBy'

import FaqModel from '@/models/FaqModel'

import ManageBaseTableHeader from '@/components/ManageBaseTableHeader'
import Markdown from '@/components/Markdown'
export default {
  name: 'MerchantSupportView',
  components: {
    ManageBaseTableHeader,
    Markdown,
  },
  meta() {
    return { title: `Support | Minimart` }
  },
  methods: {
    ...mapActions('support', ['fetchFaqs']),
    slugMe,
  },
  computed: {
    ...mapGetters('app', ['version']),
    // ...mapFields('support', ['faqs']),
    faqs() {
      return FaqModel.all()
    },
    faqByTopic() {
      return _groupBy(this.faqs, 'topic')
    },
    topics() {
      return Object.keys(this.faqByTopic)
    }, // topics
  },
  async created() {
    await this.fetchFaqs()
    if (this.$route.hash) {
      this.$scrollTo(this.$route.hash, 700, { offset: -105 })
    }
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss">
.faqs {
  ul {
    list-style-type: none;
    padding-left: 0;
    li {
      padding-left: 0px;
      a {
        text-decoration: none;
      }
    }
  }
  .topic-name {
    position: sticky;
    top: 48px;
    background: white;
    z-index: 3;
  }
  .faq-wrap {
    position: relative;
    .faq-question {
      position: sticky;
      top: 97px;
      background: white;
      z-index: 2;
    }
    .link-icon {
      position: absolute;
      top: 0.5em;
      left: -4px;
      transform: translateX(-100%);
    }
    .faq-answer {
      font-family: proxima-nova, sans-serif;
      font-weight: 600;
    }
  }
  .center-column {
    max-width: 500px;
  }
  .markdown-body strong {
    font-weight: 700;
  }
}
</style>
